import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class StripeAppliesTo extends BaseModel {
  public products: string[];

  constructor(model: Partial<StripeAppliesTo> = {}) {
    super();

    this.products = model.products ?? [];
  }
}
